module.exports = __webpack_public_path__ + "img/LOGO-FINAL-GC.11d3f0af.png";